import apiFn from 'common/services/api-service';

const api = () => apiFn('/api/cms/v1/packages/orders');

export const createOrder = async orderData =>
  api()
    .post('', orderData)
    .then(response => response.data);
